import data from './data/cluster-overview';
import ui from './ui/default';
import conf from './common/config';
import queryParams from './data/queryparams';

(function(global){
  let init = ()=>{
    // query params에 dbserver 값이 있는 경우 설정
    conf.dbserver.set(queryParams.get('dbserver'));
    data.cluster(); ui.init();
  }
  init();
}(window));


// WEBPACK FOOTER //
// ./src/scripts/app.js